module.exports = __webpack_public_path__ + "static/media/logo2.33a1f81a.png";